export enum MenuText {
  RE_INDEX = 'reindex',
  RE_INDEX_FOR = 'reindexFor',
  UNBIND = 'remove aliases and lock PQID',
  DESTROY_FROM_SERVICES = 'delete user from current app',
  DESTROY_FROM_SERVICES_AND_APPS = 'delete user from all apps',
}
export interface ButtonIndex {
  text: MenuText;
  onClick: () => void;
  access: boolean;
}
